import { render, staticRenderFns } from "./personnelType.vue?vue&type=template&id=98841fae&scoped=true&"
import script from "./personnelType.vue?vue&type=script&lang=js&"
export * from "./personnelType.vue?vue&type=script&lang=js&"
import style0 from "./personnelType.vue?vue&type=style&index=0&id=98841fae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98841fae",
  null
  
)

export default component.exports